import React, { useState } from 'react';
import { Box, Button, Collapse, Link, Switch, Typography } from '@mui/material';

interface Props {
  /** Le client a coché l'engagement. */
  accepte: boolean;
  onChange: (accepte: boolean) => void;
}

const TEXTE_CGV = `Formulaire fourni par Visa Monde et nécessairement rempli et retourné à Visa Monde par le Client lors de sa demande de Prestation.
Ce formulaire peut être un Bon de Commande Visa si le Client a recours à Visa Monde pour une demande de visa, ou un Bon de Commande Légalisation,
si le Client a recours à Visa Monde pour une demande de légalisation d'un document.

L'envoi du Bon de commande par le Client à Visa Monde vaut acceptation de l'offre de Prestation et engagement de la payer.

Dans tous les cas, le Client devra nécessairement remplir et signer un formulaire nommé Bon de Commande Visa en cas de demande de visa
et un Bon de Commande Légalisation en cas de demande de légalisation.

Ces deux documents sont désignés ci-après sous la dénomination unique « Bon de Commande ».

Le Bon de Commande devra être remis à Visa Monde soit directement au guichet (lorsque la commande est faite au guichet),
soit par courrier postal ou pli déposé par porteur.

Aucune demande de Prestation ne sera traitée sans remise de Bon de Commande intégralement rempli et dûment signé.
Les informations renseignées par le Client sur le Bon de Commande déterminent la Prestation sollicitée par le Client
et conditionnent la demande de visa ou de légalisation de documents que transmettra Visa Monde auprès des Autorités Compétentes.

Visa Monde constitue le dossier du Client uniquement au regard des informations reportées sur le Bon de Commande.
En aucun cas, Visa Monde ne vérifie l'exactitude des informations reportées sur le Bon de Commande, quand bien même d'autres documents
fournis par le Client viendraient les contredire.

Il appartient donc au Client de fournir des informations sincères, exactes et complètes. En cas de demande de visa, il doit notamment indiquer la date
d'entrée et de sortie de l'ensemble des Etats qu'il traversera au cours de son voyage, y compris les Etats dans lesquels il ne ferait que transiter.
Le Client doit s'assurer que l'identité renseignée sur le Bon de Commande est conforme à celle de son ou ses documents de voyage.

En cas de demande de légalisation de documents, le Client doit renseigner le Bon de commande et la date limite
à laquelle il souhaite recevoir les documents légalisés.

La remise du Bon de commande par le Client à Visa Monde vaut acceptation de l'offre de Prestation, du tarif de la Prestation et des présentes conditions générales de ventes.

Le Client s'engage à communiquer des coordonnées à jour et à informer Visa Monde sans délai de tout changement survenu depuis l'envoi du Bon de Commande.`;

/**
 * Engagement sur les CGV, sans le module d'assurance : les formulaires e-Card ne
 * proposent pas l'assurance visa mais doivent recueillir le même consentement,
 * que FormChineECard et FormIndeECard portaient chacun en copie interne.
 */
const ConditionsGeneralesVente: React.FC<Props> = ({ accepte, onChange }) => {
  const [afficheConditions, setAfficheConditions] = useState(false);

  return (
    <Box sx={{ my: 3, p: 2 }}>
      <Collapse in={afficheConditions}>
        <Box
          sx={{
            border: '1px solid #ccc',
            borderRadius: 2,
            p: 2,
            mb: 2,
            backgroundColor: '#f9f9f9',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Conditions générales de vente
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'justify', whiteSpace: 'pre-line', mb: 2 }}>
            {TEXTE_CGV}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => setAfficheConditions(false)}
            sx={{ display: 'block', mx: 'auto' }}
            type="button"
          >
            Fermer
          </Button>
        </Box>
      </Collapse>

      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          En validant, j'accepte les{' '}
          <Link
            component="button"
            type="button"
            variant="body1"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              setAfficheConditions(true);
            }}
            sx={{ textDecoration: 'underline', color: '#0645AD' }}
          >
            conditions générales de ventes
          </Link>
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Switch checked={accepte} onChange={(e) => onChange(e.target.checked)} color="primary" />
          <Typography variant="body1" sx={{ ml: 1 }}>
            Oui
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ConditionsGeneralesVente;
